import { baseApi as api } from './api.base.js';
const injectedRtkApi = api.injectEndpoints({
  endpoints: (build) => ({
    marketingCampaignsAdminControllerCreateMarketingCampaignV1: build.mutation<
      MarketingCampaignsAdminControllerCreateMarketingCampaignV1ApiResponse,
      MarketingCampaignsAdminControllerCreateMarketingCampaignV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/marketing-campaigns`,
        method: 'POST',
        body: queryArg.createMarketingCampaignBody,
      }),
    }),
    marketingCampaignsAdminControllerListMarketingCampaignsV1: build.query<
      MarketingCampaignsAdminControllerListMarketingCampaignsV1ApiResponse,
      MarketingCampaignsAdminControllerListMarketingCampaignsV1ApiArg
    >({
      query: () => ({ url: `/api/v1/admin/marketing-campaigns` }),
    }),
    marketingCampaignsAdminControllerListMarketingSourcesV1: build.query<
      MarketingCampaignsAdminControllerListMarketingSourcesV1ApiResponse,
      MarketingCampaignsAdminControllerListMarketingSourcesV1ApiArg
    >({
      query: () => ({ url: `/api/v1/admin/marketing-campaigns/sources` }),
    }),
    marketingCampaignsAdminControllerListMarketingMediumsV1: build.query<
      MarketingCampaignsAdminControllerListMarketingMediumsV1ApiResponse,
      MarketingCampaignsAdminControllerListMarketingMediumsV1ApiArg
    >({
      query: () => ({ url: `/api/v1/admin/marketing-campaigns/mediums` }),
    }),
    marketingCampaignsAdminControllerGetMarketingCampaignV1: build.query<
      MarketingCampaignsAdminControllerGetMarketingCampaignV1ApiResponse,
      MarketingCampaignsAdminControllerGetMarketingCampaignV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/marketing-campaigns/${queryArg.id}`,
      }),
    }),
    marketingCampaignsAdminControllerUpdateMarketingCampaignV1: build.mutation<
      MarketingCampaignsAdminControllerUpdateMarketingCampaignV1ApiResponse,
      MarketingCampaignsAdminControllerUpdateMarketingCampaignV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/marketing-campaigns/${queryArg.id}`,
        method: 'PUT',
        body: queryArg.updateMarketingCampaignBody,
      }),
    }),
    marketingCampaignsAdminControllerDeleteMarketingCampaignV1: build.mutation<
      MarketingCampaignsAdminControllerDeleteMarketingCampaignV1ApiResponse,
      MarketingCampaignsAdminControllerDeleteMarketingCampaignV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/admin/marketing-campaigns/${queryArg.id}`,
        method: 'DELETE',
      }),
    }),
    marketingCampaignsControllerGetMarketingCampaignBySlugV1: build.query<
      MarketingCampaignsControllerGetMarketingCampaignBySlugV1ApiResponse,
      MarketingCampaignsControllerGetMarketingCampaignBySlugV1ApiArg
    >({
      query: (queryArg) => ({
        url: `/api/v1/marketing-campaigns/${queryArg.slug}`,
      }),
    }),
  }),
  overrideExisting: false,
});
export { injectedRtkApi as generatedApi };
export type MarketingCampaignsAdminControllerCreateMarketingCampaignV1ApiResponse =
  /** status 200 Returns created marketing campaign */ CreateMarketingCampaignResponse;
export type MarketingCampaignsAdminControllerCreateMarketingCampaignV1ApiArg = {
  createMarketingCampaignBody: CreateMarketingCampaignBody;
};
export type MarketingCampaignsAdminControllerListMarketingCampaignsV1ApiResponse =
  /** status 200 Returns the list of marketing campaigns */ ListMarketingCampaignsResponse;
export type MarketingCampaignsAdminControllerListMarketingCampaignsV1ApiArg = void;
export type MarketingCampaignsAdminControllerListMarketingSourcesV1ApiResponse =
  /** status 200 Returns the list of marketing sources */ ListMarketingSourcesResponse;
export type MarketingCampaignsAdminControllerListMarketingSourcesV1ApiArg = void;
export type MarketingCampaignsAdminControllerListMarketingMediumsV1ApiResponse =
  /** status 200 Returns the list of marketing mediums */ ListMarketingMediumsResponse;
export type MarketingCampaignsAdminControllerListMarketingMediumsV1ApiArg = void;
export type MarketingCampaignsAdminControllerGetMarketingCampaignV1ApiResponse =
  /** status 200 Marketing campaign details */ GetMarketingCampaignResponse;
export type MarketingCampaignsAdminControllerGetMarketingCampaignV1ApiArg = {
  id: number;
};
export type MarketingCampaignsAdminControllerUpdateMarketingCampaignV1ApiResponse =
  /** status 200 Returns updated marketing campaign */ UpdateMarketingCampaignResponse;
export type MarketingCampaignsAdminControllerUpdateMarketingCampaignV1ApiArg = {
  id: number;
  updateMarketingCampaignBody: UpdateMarketingCampaignBody;
};
export type MarketingCampaignsAdminControllerDeleteMarketingCampaignV1ApiResponse =
  /** status 200 Returns deleted marketing campaign */ DeleteMarketingCampaignResponse;
export type MarketingCampaignsAdminControllerDeleteMarketingCampaignV1ApiArg = {
  id: number;
};
export type MarketingCampaignsControllerGetMarketingCampaignBySlugV1ApiResponse =
  /** status 200 Marketing campaign details */ GetMarketingCampaignBySlugResponse;
export type MarketingCampaignsControllerGetMarketingCampaignBySlugV1ApiArg = {
  slug: string;
};
export type CreateMarketingCampaignResponse = {
  /** Marketing Campaign ID */
  id: number;
  /** Campaign slug (unique, 1-32 chars, lowercase, numbers, dash/underscore) */
  slug: string;
  /** UTM id */
  utmId: null | string;
  /** UTM medium (1-32 chars) */
  utmMedium: string;
  /** UTM source (1-32 chars) */
  utmSource: string;
  /** UTM campaign */
  utmCampaign: null | string;
  /** UTM content */
  utmContent: null | string;
  /** UTM term */
  utmTerm: null | string;
  /** Campaign start date */
  startDate: null | string;
  /** Campaign end date */
  endDate: null | string;
  /** Campaign comment */
  comment: null | string;
  /** User CRC or null */
  userCrc: null | number;
  /** Target URL */
  targetUrl: null | string;
  /** Creation timestamp */
  createdAt: string;
  /** User ID who created */
  createdBy: number;
  /** Update timestamp */
  updatedAt: string;
  /** User ID who updated */
  updatedBy: number;
  /** Campaign complete URL */
  url?: string;
};
export type CreateMarketingCampaignBody = {
  /** Campaign slug (unique, 1-32 chars, lowercase, numbers, dash/underscore) */
  slug: string;
  /** UTM medium (1-32 chars) */
  utmMedium: string;
  /** UTM source (1-32 chars) */
  utmSource: string;
  /** UTM id */
  utmId?: null | string;
  /** UTM campaign */
  utmCampaign?: null | string;
  /** UTM content */
  utmContent?: null | string;
  /** UTM term */
  utmTerm?: null | string;
  /** Campaign start date */
  startDate?: null | string;
  /** Campaign end date */
  endDate?: null | string;
  /** Campaign comment */
  comment?: null | string;
  /** User CRC or null */
  userCrc?: null | number;
  /** Target URL */
  targetUrl?: null | string;
};
export type ListMarketingCampaignsResponse = {
  /** Marketing Campaign ID */
  id: number;
  /** Campaign slug (unique, 1-32 chars, lowercase, numbers, dash/underscore) */
  slug: string;
  /** UTM id */
  utmId: null | string;
  /** UTM medium (1-32 chars) */
  utmMedium: string;
  /** UTM source (1-32 chars) */
  utmSource: string;
  /** UTM campaign */
  utmCampaign: null | string;
  /** UTM content */
  utmContent: null | string;
  /** UTM term */
  utmTerm: null | string;
  /** Campaign start date */
  startDate: null | string;
  /** Campaign end date */
  endDate: null | string;
  /** Campaign comment */
  comment: null | string;
  /** User CRC or null */
  userCrc: null | number;
  /** Target URL */
  targetUrl: null | string;
  /** Creation timestamp */
  createdAt: string;
  /** User ID who created */
  createdBy: number;
  /** Update timestamp */
  updatedAt: string;
  /** User ID who updated */
  updatedBy: number;
  /** Campaign complete URL */
  url?: string;
}[];
export type ListMarketingSourcesResponse = {
  label: string;
  value: string;
}[];
export type ListMarketingMediumsResponse = {
  label: string;
  value: string;
}[];
export type GetMarketingCampaignResponse = {
  /** Marketing Campaign ID */
  id: number;
  /** Campaign slug (unique, 1-32 chars, lowercase, numbers, dash/underscore) */
  slug: string;
  /** UTM id */
  utmId: null | string;
  /** UTM medium (1-32 chars) */
  utmMedium: string;
  /** UTM source (1-32 chars) */
  utmSource: string;
  /** UTM campaign */
  utmCampaign: null | string;
  /** UTM content */
  utmContent: null | string;
  /** UTM term */
  utmTerm: null | string;
  /** Campaign start date */
  startDate: null | string;
  /** Campaign end date */
  endDate: null | string;
  /** Campaign comment */
  comment: null | string;
  /** User CRC or null */
  userCrc: null | number;
  /** Target URL */
  targetUrl: null | string;
  /** Creation timestamp */
  createdAt: string;
  /** User ID who created */
  createdBy: number;
  /** Update timestamp */
  updatedAt: string;
  /** User ID who updated */
  updatedBy: number;
  /** Campaign complete URL */
  url?: string;
};
export type UpdateMarketingCampaignResponse = {
  /** Marketing Campaign ID */
  id: number;
  /** Campaign slug (unique, 1-32 chars, lowercase, numbers, dash/underscore) */
  slug: string;
  /** UTM id */
  utmId: null | string;
  /** UTM medium (1-32 chars) */
  utmMedium: string;
  /** UTM source (1-32 chars) */
  utmSource: string;
  /** UTM campaign */
  utmCampaign: null | string;
  /** UTM content */
  utmContent: null | string;
  /** UTM term */
  utmTerm: null | string;
  /** Campaign start date */
  startDate: null | string;
  /** Campaign end date */
  endDate: null | string;
  /** Campaign comment */
  comment: null | string;
  /** User CRC or null */
  userCrc: null | number;
  /** Target URL */
  targetUrl: null | string;
  /** Creation timestamp */
  createdAt: string;
  /** User ID who created */
  createdBy: number;
  /** Update timestamp */
  updatedAt: string;
  /** User ID who updated */
  updatedBy: number;
  /** Campaign complete URL */
  url?: string;
};
export type UpdateMarketingCampaignBody = {
  /** UTM id */
  utmId?: null | string;
  /** UTM medium (1-32 chars) */
  utmMedium?: string;
  /** UTM source (1-32 chars) */
  utmSource?: string;
  /** UTM campaign */
  utmCampaign?: null | string;
  /** UTM content */
  utmContent?: null | string;
  /** UTM term */
  utmTerm?: null | string;
  /** Campaign start date */
  startDate?: null | string;
  /** Campaign end date */
  endDate?: null | string;
  /** Campaign comment */
  comment?: null | string;
  /** User CRC or null */
  userCrc?: null | number;
  /** Target URL */
  targetUrl?: null | string;
};
export type DeleteMarketingCampaignResponse = {
  /** Marketing Campaign ID */
  id: number;
  /** Campaign slug (unique, 1-32 chars, lowercase, numbers, dash/underscore) */
  slug: string;
  /** UTM id */
  utmId: null | string;
  /** UTM medium (1-32 chars) */
  utmMedium: string;
  /** UTM source (1-32 chars) */
  utmSource: string;
  /** UTM campaign */
  utmCampaign: null | string;
  /** UTM content */
  utmContent: null | string;
  /** UTM term */
  utmTerm: null | string;
  /** Campaign start date */
  startDate: null | string;
  /** Campaign end date */
  endDate: null | string;
  /** Campaign comment */
  comment: null | string;
  /** User CRC or null */
  userCrc: null | number;
  /** Target URL */
  targetUrl: null | string;
  /** Creation timestamp */
  createdAt: string;
  /** User ID who created */
  createdBy: number;
  /** Update timestamp */
  updatedAt: string;
  /** User ID who updated */
  updatedBy: number;
  /** Campaign complete URL */
  url?: string;
};
export type GetMarketingCampaignBySlugResponse = {
  /** Marketing Campaign ID */
  id: number;
  /** Campaign slug (unique, 1-32 chars, lowercase, numbers, dash/underscore) */
  slug: string;
  /** UTM id */
  utmId: null | string;
  /** UTM medium (1-32 chars) */
  utmMedium: string;
  /** UTM source (1-32 chars) */
  utmSource: string;
  /** UTM campaign */
  utmCampaign: null | string;
  /** UTM content */
  utmContent: null | string;
  /** UTM term */
  utmTerm: null | string;
  /** Campaign start date */
  startDate: null | string;
  /** Campaign end date */
  endDate: null | string;
  /** Campaign comment */
  comment: null | string;
  /** User CRC or null */
  userCrc: null | number;
  /** Target URL */
  targetUrl: null | string;
  /** Creation timestamp */
  createdAt: string;
  /** User ID who created */
  createdBy: number;
  /** Update timestamp */
  updatedAt: string;
  /** User ID who updated */
  updatedBy: number;
  /** Campaign complete URL */
  url?: string;
};
